import { ChevronLeft, ChevronRight } from "lucide-react";

// Edge drawer: slides in from its side over the full-screen map. Handle stays docked to the drawer edge.
export default function EdgeDrawer({ side, open, onToggle, label, Icon, dot, testid, children, otherOpen, fill }) {
  const left = side === "left";
  const Chevron = (left ? open : !open) ? ChevronLeft : ChevronRight;
  return (
    <>
      <aside
        data-testid={`${testid}-panel`}
        aria-hidden={!open}
        className={`room-hide absolute top-0 bottom-0 ${left ? "left-0 border-r" : "right-0 border-l"} z-[700] w-full sm:w-[420px] lg:w-[440px]
          bg-[#020b24]/92 backdrop-blur-xl border-cyan/25 shadow-[0_0_60px_rgba(0,0,0,0.6)]
          transition-transform duration-[380ms] ease-[cubic-bezier(0.16,1,0.3,1)]
          ${open ? "translate-x-0" : left ? "-translate-x-full" : "translate-x-full"}`}
      >
        <div className={fill ? "h-full p-3 flex flex-col gap-3 min-h-0" : "h-full overflow-y-auto p-3 space-y-3 drawer-scroll"}>{children}</div>
      </aside>
      <button
        data-testid={`${testid}-toggle-button`}
        onClick={onToggle}
        aria-expanded={open}
        className={`room-hide absolute top-1/2 -translate-y-1/2 z-[710] w-9 h-32 flex flex-col items-center justify-center gap-2
          bg-[#012173] hover:bg-[#03268a] text-cyan border border-cyan/40 shadow-[0_0_24px_rgba(252,193,9,0.25)]
          transition-[left,right,background-color] duration-[380ms] ease-[cubic-bezier(0.16,1,0.3,1)]
          ${left ? "rounded-r-xl border-l-0" : "rounded-l-xl border-r-0"} ${otherOpen ? "max-sm:hidden" : ""}
          ${left ? (open ? "left-[calc(100%-2.25rem)] sm:left-[420px] lg:left-[440px]" : "left-0")
                 : (open ? "right-[calc(100%-2.25rem)] sm:right-[420px] lg:right-[440px]" : "right-0")}`}
      >
        {dot && <span className="w-2 h-2 rounded-full pulse-dot" style={{ background: dot, boxShadow: `0 0 8px ${dot}` }} />}
        <Icon className="w-4 h-4" />
        <span className="font-heading text-[11px] font-semibold uppercase tracking-[0.2em] [writing-mode:vertical-rl] rotate-180">
          {label}
        </span>
        <Chevron className="w-4 h-4" />
      </button>
    </>
  );
}
